import { Time } from '../types/common.types';

import { SHORT_MONTHS } from './constants';

export const formatUTCDate = (date: string | Date) => {
  const dateObject = new Date(date);
  const day = dateObject.getUTCDate();
  let hours: string | number = dateObject.getUTCHours();
  let minutes: string | number = dateObject.getUTCMinutes();

  if (hours < 10) {
    hours = `0${hours}`;
  }

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  const currentDate = new Date();
  if (
    day === currentDate.getUTCDate() &&
    dateObject.getUTCMonth() === currentDate.getUTCMonth() &&
    dateObject.getUTCFullYear() === currentDate.getUTCFullYear()
  ) {
    return `Today at ${hours}:${minutes}`;
  }

  if (
    day === currentDate.getUTCDate() - 1 &&
    dateObject.getUTCMonth() === currentDate.getUTCMonth() &&
    dateObject.getUTCFullYear() === currentDate.getUTCFullYear()
  ) {
    return `Yesterday at ${hours}:${minutes}`;
  }

  const month = SHORT_MONTHS[dateObject.getUTCMonth()];

  return `${day} ${month} at ${hours}:${minutes}`;
};

export const formatDate = (date: string | Date) => {
  const dateObject = new Date(date);
  const day = dateObject.getDate();
  let hours: string | number = dateObject.getHours();
  let minutes: string | number = dateObject.getMinutes();

  if (hours < 10) {
    hours = `0${hours}`;
  }

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  const currentDate = new Date();
  if (
    day === currentDate.getDate() &&
    dateObject.getMonth() === currentDate.getMonth() &&
    dateObject.getFullYear() === currentDate.getFullYear()
  ) {
    return `Today at ${hours}:${minutes}`;
  }

  if (
    day === currentDate.getDate() - 1 &&
    dateObject.getMonth() === currentDate.getMonth() &&
    dateObject.getFullYear() === currentDate.getFullYear()
  ) {
    return `Yesterday at ${hours}:${minutes}`;
  }

  const month = SHORT_MONTHS[dateObject.getMonth()];

  return `${day} ${month} at ${hours}:${minutes}`;
};

export const convertDateToTime = (date: Date | string) => {
  if (!date) return undefined;

  let dateObject: Date;
  if (typeof date === 'string') {
    dateObject = new Date(date);
  } else {
    dateObject = date;
  }

  let hours = dateObject.getUTCHours();
  const isAM = hours < 12;

  if (!isAM) {
    hours -= 12;
  }

  if (hours === 0) {
    hours = 12;
  }

  const time: Time = {
    hours: hours.toString().padStart(2, '0'),
    minutes: dateObject.getUTCMinutes().toString().padStart(2, '0'),
    isAM
  };

  return time;
};

export const convertTimeToDate = (time: Time) => {
  const date = new Date();
  let hours = Number(time.hours);

  if (!time.isAM && hours < 12) {
    hours += 12;
  } else if (time.isAM && hours === 12) {
    hours = 0;
  }

  date.setUTCHours(hours);
  date.setUTCMinutes(Number(time.minutes));
  date.setUTCSeconds(0);
  date.setUTCMilliseconds(0);

  return date;
};
